import styled from 'styled-components';

const colors = require('common/lib/colors/colors.less');

export const ReactionContainer = styled.div`
  background: ${colors.white};
  margin: 14px 0px -4px 0px;
  line-height: 2em;
  display: flex;
  flex-flow: row wrap;
`;



// WEBPACK FOOTER //
// ./app/common/components/canonical-components/canonical-detail/ReactionContainer.js